module.exports = __webpack_public_path__ + "media/Audio17_o.ed3d5b4a.wav";